import React, { useEffect } from "react";
import {
    Box,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    CircularProgress,
    Alert,
    Chip,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../Redux/Store/Hooks";
import { getScreenList } from "../../Redux/Slices/Screen/ScreenList";

interface Screen {
    screen_id: string;
    name: string;
    path: string;
    url: string;
    icon: string;
    screen_order: number;
    status: boolean;
    delete_flag: boolean;
}

const ScreenMaster: React.FC = () => {
    const dispatch = useDispatch();

    const { data: screenData, isLoading } = useAppSelector(
        (state) => state.ScreenList
    );

    useEffect(() => {
        dispatch(getScreenList());
    }, [dispatch]);

    const screens: Screen[] = screenData?.data || [];
    const loading = isLoading || false;
    const error = screenData?.status === false ? screenData?.message : null;

    if (loading) {
        return (
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                minHeight="400px"
            >
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box p={3}>
                <Alert severity="error">{error}</Alert>
            </Box>
        );
    }

    return (
        <Box p={3}>
            <Typography variant="h5" fontWeight={600} mb={3}>
                Screen Master
            </Typography>

            <TableContainer
                component={Paper}
                sx={{
                    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
                    borderRadius: 2,
                }}
            >
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                            <TableCell sx={{ fontWeight: 600, fontSize: 14 }}>
                                Screen Name
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: 14 }}>
                                Path
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {screens.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                                    <Typography color="text.secondary">
                                        No screens found
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ) : (
                            screens.map((screen) => (
                                <TableRow
                                    key={screen.screen_id}
                                    sx={{
                                        "&:hover": { backgroundColor: "#f9f9f9" },
                                        opacity: screen.delete_flag ? 0.5 : 1,
                                    }}
                                >
                                    <TableCell>
                                        <Typography fontWeight={500}>{screen.name}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontFamily: "monospace",
                                                backgroundColor: "#f0f0f0",
                                                padding: "4px 8px",
                                                borderRadius: 1,
                                                display: "inline-block",
                                            }}
                                        >
                                            {screen.path || "-"}
                                       
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box mt={2}>
                <Typography variant="body2" color="text.secondary">
                    Total Screens: {screens.length}
                </Typography>
            </Box>
        </Box>
    );
};

export default ScreenMaster;
